import Login from "./components/Login";
import Schedule from "./components/Schedule";
import ScoreGrid from "./components/ScoreGrid";
import ProtectedRoutes from "./utils/ProtectedRoutes";
import { AuthProvider } from "./utils/AuthProvider";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

const App = () => {
  return (
    <>
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route element={<ProtectedRoutes />}>
              <Route path="/update" element={<ScoreGrid disabled={false} />} />
            </Route>
            <Route path="/" element={<ScoreGrid disabled={true} />} />
          </Routes>
        </AuthProvider>
      </Router>
    </>
  );
};

export default App;
